import type React from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description, children }) => {
  return (
    <div className="p-6 border border-border/50 bg-card/50 backdrop-blur-sm hover:shadow-lg transition-shadow">
      <div className="w-12 h-12 rounded-sm bg-primary/10 flex items-center justify-center mb-4">
        {icon}
      </div>
      <h2 className="text-xl font-semibold mb-2">{title}</h2>
      {children ? (
        <div className="text-muted-foreground">{children}</div>
      ) : (
        <p className="text-muted-foreground">{description}</p>
      )}
    </div>
  );
};
